// @flow
import React from 'react';
import PropTypes from 'prop-types';
import DialogPortal from './DialogPortal';
import withBoundary from 'component/ErrorBoundary/withBoundary';

/**
 * Component meant to render a drawer at the bottom of the screen,
 * by creating a portal containing the component's children.
 *
 * @returns {ReactElement}
 */
function JitsiPortal({ children, className }) {
  return (
    <DialogPortal className={`drawer-portal ${className ?? ''}`}>
      {children}
    </DialogPortal>
  );
}
JitsiPortal.propTypes = {
  /**
   * The component(s) to be displayed within the drawer portal.
   */
  children: PropTypes.any,

  /**
   * Custom class name to apply on the container div.
   */
  className: PropTypes.string
};
export default React.memo(withBoundary(JitsiPortal));
